module.exports = __webpack_public_path__ + "images/icons/flags/CH-4c5e8019.svg";